var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sms-container" }, [
    _c("div", { staticClass: "sms-header" }, [
      _c("div", { staticClass: "sms-header-box" }, [
        _c("div", { staticClass: "sms-global-menu" }, [
          _c("img", {
            staticClass: "hna-logo",
            attrs: { src: require("../../assets/fd_hna_logo.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "sms-system-name" }, [
            _vm._v("数字化安全管理平台")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sms-menus" },
            [
              _c("router-link", { attrs: { to: { name: "safeMap" } } }, [
                _vm._v("安全地图")
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: { name: "safeResult" } } }, [
                _vm._v("安全结果")
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: { name: "coreRisk" } } }, [
                _vm._v("核心风险")
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: { name: "operationOverview" } } },
                [_vm._v("运行概况")]
              ),
              _vm._v(" "),
              _c("router-link", { attrs: { to: { name: "keyProcess" } } }, [
                _vm._v("关键流程")
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: { name: "kpiMonitoring" } } }, [
                _vm._v("KPI告警监控")
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: { name: "safeExamine" } } }, [
                _vm._v("安全考核")
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sms-global-ctrl" }, [
          _c(
            "div",
            { staticClass: "sms-company el-select-wrapper" },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  on: { change: _vm.onCompanyChange },
                  model: {
                    value: _vm.selectCompany,
                    callback: function($$v) {
                      _vm.selectCompany = $$v
                    },
                    expression: "selectCompany"
                  }
                },
                _vm._l(_vm.companyOptions, function(item) {
                  return _c("el-option", {
                    key: item.code,
                    attrs: {
                      label: item.shortName ? item.shortName : item.name,
                      value: item.code
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sms-user" },
            [
              _c("i", { staticClass: "icon-user el-icon-user" }),
              _vm._v(" "),
              _c(
                "el-dropdown",
                { on: { command: _vm.handleCommand } },
                [
                  _c("span", { staticClass: "el-dropdown-link" }, [
                    _vm._v(_vm._s(_vm.user.fullName) + "\n              "),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      !_vm.enableSso
                        ? _c(
                            "el-dropdown-item",
                            { attrs: { command: "logoutDev" } },
                            [_vm._v("注销(本地调试)")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.enableSso
                        ? _c(
                            "el-dropdown-item",
                            { attrs: { command: "logout" } },
                            [_vm._v("注销")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sms-content" },
      [
        _vm.isCasLogin || _vm.company
          ? _c("router-view", {
              attrs: {
                company: _vm.company,
                companyOptions: _vm.companyOptions,
                username: _vm.user.username
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aecc73a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aecc73a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/Layout.vue
// module id = null
// module chunks = 